exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".photo-placeholder[data-v-1cbeb2f6]{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:150px;background-color:#f0f0f0;border:2px dashed #ccc;border-radius:5px;color:#999}.photo-placeholder i[data-v-1cbeb2f6]{font-size:3rem;margin-bottom:10px}.photo-placeholder span[data-v-1cbeb2f6]{font-size:1.4rem}.photo-placeholder small[data-v-1cbeb2f6]{font-size:1.1rem;color:#bbb;margin-top:3px}.photo-synced-label[data-v-1cbeb2f6]{display:block;text-align:center;color:#999;font-size:1.2rem;margin-top:5px}div.photo-container img[data-v-1cbeb2f6]{max-width:100%;max-height:600px;object-fit:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1cbeb2f6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fiches/bsdd/subcomponents/Infos.vue
// module id = 699
// module chunks = 0